import React from 'react';
import styled from 'styled-components';
import { branch, renderComponent } from 'recompose';
import { object } from 'prop-types';
import withVisibilityToggle from '../../core/enhancements/withVisibilityToggle';
import CheckoutButton from '../../core/components/product/CheckoutButtonContainer';
import Price from './Price';
import AdPrice from './AdPriceContainer';
import Characteristics from './CharacteristicsContainer';
import DiscountTag from './DiscountTagContainer';


const DefaultPackageBox = styled.article`
    box-sizing: border-box;
    display: block;
    padding-bottom: 20px;
    margin: 24px 16px 0;
    background: #fff;
    border-radius: 8px;
    color: #323232;
    text-align: center;
    border: solid 1px #e5e5e5;
    position: relative;
    @media(min-width: 1000px){
      flex: 0.33;
      margin: 0 5px;
      padding-left: 5px;
      padding-right: 5px;
    }
`;

const RecommendedPackageBox = styled(DefaultPackageBox)`
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08), 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  padding-top: 16px;
  @media(min-width: 1000px){
      margin-top: -16px;
  }
`;

const Title = styled.h2`
  font-size: 14px;
  font-weight: bold;
  padding: 24px 0 16px 0;
  text-transform: uppercase;
  line-height: 1.71;
  text-align: center;
  ${({ recommended }) => (recommended ? 'margin-top: -6px;' : '')}
`;

const AmountLabel = styled.span`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.4;
  text-align: center;
  color: #338093;
  border-radius: 18px;
  background-color: #e8f2fb;
  padding: 5px 15px;
`;

const SubscriptionInformation = styled.span`
  font-size: 12px;
  line-height: 1.33;
  text-align: center;
  display: block;
  color: #999999;
`;

const RecommendedBadge = styled.span`
  background-color: #ffffff;
  border-radius: 100px;
  border: solid 1px #e5e5e5;
  color: #9027b0;
  font-size: 9px;
  font-weight: bold;
  padding: 4px 10px;
  text-transform: uppercase;
  position: relative;
  top: -24px;
`;

const CheckoutButtonWrapper = styled.div`
  padding: 12px 32px;
`;

const RecommendedLabel = withVisibilityToggle(RecommendedBadge);
const DiscountLabel = withVisibilityToggle(DiscountTag);
const AdUnitPrice = withVisibilityToggle(AdPrice);

const PackageBox = branch(
  ({ recommended }) => recommended,
  renderComponent(RecommendedPackageBox),
)(DefaultPackageBox);

const ProductItem = ({ product }) => {
  const {
    recommended, title, amount, totalPrice: price, characteristics, promo, showAdUnitPrice,
    totalReferencePrice: referencePrice, tag, primary,
  } = product;

  return (
    <PackageBox recommended={recommended} data-e2e="subscription-item">
      <RecommendedLabel showIf={recommended}>Mais Vendido</RecommendedLabel>
      <DiscountLabel showIf={promo || tag || price.previous} recommended={recommended} product={product} />
      <Title recommended={recommended}>{title}</Title>
      <AmountLabel>{amount} anúncios / mês</AmountLabel>
      <Price value={price} />
      <AdUnitPrice showIf={showAdUnitPrice} price={price} amount={amount} />
      <CheckoutButtonWrapper>
        <CheckoutButton fullWidth type={(recommended || primary) ? 'primary' : 'secondary'} product={product} />
      </CheckoutButtonWrapper>
      <SubscriptionInformation>Você pode cancelar a qualquer momento</SubscriptionInformation>
      <Characteristics characteristics={characteristics} price={price} amount={amount} referencePrice={referencePrice} />
    </PackageBox>
  );
};

ProductItem.propTypes = {
  product: object.isRequired,
};

export default ProductItem;
